import { Button } from '@kanda-libs/ks-design-library';

import useAcceptQuote from './useAcceptQuote';

const AcceptQuoteButton: React.FunctionComponent = function () {
  const { isLoading, onAcceptClick } = useAcceptQuote();
  return (
    <Button.Text
      id="accept-quote"
      label="Accept & Select Payment"
      className="col-span-2"
      isLoading={isLoading}
      onClick={onAcceptClick}
    />
  );
};

export default AcceptQuoteButton;
